import React from 'react'
import './cta-banner-component.scss'
import { CTABannerProps } from '../../types'
import { concatClassName } from '../../utils/helpers'
import { Flex } from '../Flex'
import { H4 } from '../Heading'
import { P } from '../P'

const CALLBACK_LEAD_IMAGE_ALT = 'Hand holding a phone'

const CTABanner = ({
  heading,
  subHeading,
  ButtonComponent,
  classes,
  leadImageSrc,
  leadImageAlt = CALLBACK_LEAD_IMAGE_ALT,
}: CTABannerProps) => {
  const hasLeadImage = Boolean(leadImageSrc)

  return (
    <div
      className={`cta-banner-container ${
        hasLeadImage ? 'cta-banner-container--with-lead-image' : ''
      } ${concatClassName(classes)}`}
    >
      {hasLeadImage && leadImageSrc ? (
        <img
          className='cta-banner-container__lead-image'
          src={leadImageSrc}
          alt={leadImageAlt}
          width={160}
          height={120}
          loading='lazy'
          decoding='async'
        />
      ) : null}
      <Flex variant='column' classes={hasLeadImage ? ['cta-banner-container__copy'] : undefined}>
        {heading && <H4 text={heading} />}
        {subHeading && (
          <P text={subHeading} classes={['mt-24']} textSize='regular' variant='default-gray' />
        )}
      </Flex>
      {ButtonComponent}
    </div>
  )
}

export { CTABanner }
